<template lang="pug">
.toolbar
  a(href="/")
    .logo
      BriqIcon(name="icon-beeldmerk")
  .toolbar-bottom
    button.help-button(@click="clickHelpButton")
      BriqIcon(name="icon-question-mark" :customStyle="{ fontSize: '18px', color: 'white' }")
    a.settings-link(href="/settings/application/main")
      BriqIcon(name="icon-manage-menu-icon" :customStyle="{ fontSize: '18px', color: 'white' }")
    .account-button
      button(@click="clickAccountButton")
        img.account-image(:src="userDetails.imageUrl")
  BriqAccountMenu(ref="accountMenu" v-show="accountMenuIsOpen")
  BriqHelpMenu(ref="helpMenu" v-show="helpMenuIsOpen")
</template>

<script>
import BriqAccountMenu from './BriqAccountMenu.vue'
import BriqHelpMenu from './BriqHelpMenu.vue'
import { mapState } from 'vuex'

export default {
  name: 'BriqToolbar',
  components: { BriqAccountMenu, BriqHelpMenu },
  data() {
    return {
      accountMenuIsOpen: false,
      helpMenuIsOpen: false,
    }
  },
  computed: mapState('user', ['userDetails']),
  methods: {
    closeMenu() {
      this.accountMenuIsOpen = false
      this.helpMenuIsOpen = false
    },
    addListener(menu) {
      this.removeListener()
      const closeMenu = this.closeMenu
      this.listener = event => {
        const clickInMenu = menu.isSameNode(event.target) || menu.contains(event.target)
        if (!clickInMenu) closeMenu()
        event.stopPropagation()
      }
      setTimeout(() => {
        this.$document.body.addEventListener('click', this.listener)
      }, 100)
    },
    removeListener() {
      this.$document.body.removeEventListener('click', this.listener)
    },
    clickHelpButton() {
      this.accountMenuIsOpen = false
      this.helpMenuIsOpen = !this.helpMenuIsOpen
    },
    clickAccountButton() {
      this.helpMenuIsOpen = false
      this.accountMenuIsOpen = !this.accountMenuIsOpen
    },
  },
  watch: {
    accountMenuIsOpen(newVal) {
      const menu = this.$refs.accountMenu.$vnode.elm // this gets the DOM element
      if (newVal) this.addListener(menu)
      else this.removeListener()
    },
    helpMenuIsOpen(newVal) {
      const menu = this.$refs.helpMenu.$vnode.elm
      if (newVal) this.addListener(menu)
      else this.removeListener()
    },
  },
}
</script>

<style scoped lang="stylus">
.toolbar
  width 70px
  background #000d28
  position fixed
  top 0
  left 0
  bottom 0
  padding 24px 0
  display flex
  flex-direction column
  justify-content space-between
  color #fff

  .logo
    color #009bff
    font-size 30px
    text-align center

  .toolbar-bottom
    display flex
    flex-direction column

    .help-button, .settings-link
      text-align center
      margin-bottom 20px
      cursor pointer

    .account-button
      text-align center

      button
        height 36px
        width 36px
        padding 0
        display inline-block

        .account-image
          width 100%
          height 100%
          object-fit cover
          border-radius 50%
</style>
